// Utils file for the app
//    - @author Daniel Pribeagu <daniel.pribeagu@hp.com>
//    - @date May 31st 2023
//    - @copyright Copyright (c) HP Inc, 2023
//        All rights reserved. Copying or other reproduction of this program except
//        for archival purposes is prohibited without written consent of HP Inc.
// getHotjarID returns the Hotjar ID based on the stack
// @param stack - the stack of the app

import { Stack } from '../types/stratus';

// @returns the Hotjar ID
export const getHotjarID = (stack: Stack) => {
  if (stack === Stack.prod) return 3487423;
  else return 3382859;
};
